<template>
  <!-- 高级参照管理 -->
  <div data-app="true">
    <div
      class="parentPage"
      style="position: relative"
      v-if="$route.name == 'referToList'"
    >
      <v-btn
        rounded
        v-if="$route.name == 'referToList'"
        depressed
        height="40"
        style="position: absolute;top:-65px;right:64px;"
        color="primary"
        :loading="refreshLoading"
        @click="refreshCache"
        dark
      >
        {{ $t("label_refresh") }}
      </v-btn>
      <mrc_ess_table
        :headers="headers"
        :hideAddBtn="!hasBtn('add-data-reference')"
        pageName="add-reference"
        :paginationOptions="params"
        @turnPage="getData"
        :slotKey="['prompt_type', 'source_table']"
        :isLoading="loading"
        :items="desserts"
      >
        <template v-slot:search>
          <v-row
            class="d-flex justify-end"
            style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
          >
            <mrc_ess_advanceFilterAndSearchInput
              class="mt-4"
              v-model="systemSeniorQueryString"
              @success="getData({ cpage: 1 })"
              :systemFieldMeta="systemFieldMeta"
            ></mrc_ess_advanceFilterAndSearchInput>
          </v-row>
        </template>

        <template v-slot:item.prompt_type="{ item }">
          <mrc_ess_dictName
            v-model="item.prompt_type"
            :select_arr="select_arr"
            view
          >
          </mrc_ess_dictName>
        </template>

        <template v-slot:item.source_table="{ item }">
          <v-chip
            small
            class="mb-1 mr-1"
            v-for="(item1, index) in splitINT(item.source_table)"
            :key="index"
          >
            {{ item1 }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <menu-list :list="list" @handleClick="handleClick($event, item)">
            <template v-slot:showAction>
              <v-icon
                v-btnAuth="[
                  'view-data-reference',
                  'edit-data-reference',
                  'delete-data-reference',
                ]"
                >mdi-dots-vertical</v-icon
              >
            </template>
          </menu-list>
        </template>
      </mrc_ess_table>
    </div>
    <!-- 这是当前页的子页面  嵌套路由 -->
    <transition name="fade-transform" mode="out-in" v-else>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { get_dict_name } from "@/service/api/data_dictionary"
import { getList, getDetele, refresh } from "@/service/api/prompt"
import confirm from "@/components/confirm"
export default {
  components: { confirm },
  props: {},
  data() {
    return {
      refreshLoading: false,
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      isLoading: false,
      select_arr: [],
      params: {
        "~table~": "mrbase_sys_prompt",
        cpage: this.$store.state.cpage,
        pagesize: this.$store.state.pageSize,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      desserts: [],
      loading: false,
    }
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  mounted() {
    get_dict_name({ dict_name: "prompt_type" }).then((res) => {
      if (res.code == 200) {
        this.select_arr = res.data
      }
    })
    // this.getBtnPermissionList()
    this.getData()
  },
  methods: {
    async refreshCache() {
      this.refreshLoading = true
      try {
        const res = await refresh({ "~table~": "mrbase_sys_prompt" })
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          })
        }
        this.refreshLoading = false
      } catch (err) {
        this.refreshLoading = false
      }
    },
    getData(obj) {
      if (obj) {
        this.params = Object.assign({}, this.params, obj)
      }
      this.loading = true
      getList({
        cpage: this.params.cpage,
        pagesize: this.params.pagesize,
        "~table~": this.params["~table~"],
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
        .then((res) => {
          this.loading = false
          this.showSkeleton = false
          this.desserts = [...res.data]
          // this.totalpage = res.totalpage
          // this.$set(this.params, 'totalcount', res.totalcount)
          // this.$set(
          //   this.params,
          //   'totalpage',
          //   Math.ceil(res.totalcount / res.pagesize)
          // )
          this.params.totalcount = res.totalcount
          this.params.totalpage = Math.ceil(res.totalcount / res.pagesize)
          this.systemFieldMeta = res.systemFieldMeta
          this.field_alias_name = res.field_alias_name
          this.table_alias_name = res.table_alias_name
          // this.totalpage = Math.ceil(res.totalcount / res.pagesize)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleClick({ index }, item) {
      if (index == 0) {
        this.$store.commit("set_subPage_name", item.prompt_name)
        this.$store.commit("set_uuid", item.uuid)
        this.$store.commit("set_iconstatus", true)
        this.$router.push({
          name: "detail-reference",
          params: {
            name: item.prompt_name,
            uuid: item.uuid,
          },
        })
      }
      // 编辑
      if (index == 1) {
        this.editPrompt(item)
      }
      if (index == 2) {
        this.handleDel(item)
      }
    },
    // 编辑
    editPrompt(item) {
      this.$store.commit("set_subPage_name", item.prompt_name)
      this.$store.commit("set_uuid", item.uuid)
      this.$store.commit("set_iconstatus", false)
      this.$router.push({
        name: "detail-reference",
        params: {
          name: item.prompt_name,
          uuid: item.uuid,
        },
      })
    },
    // 点击删除
    handleDel(item) {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(() => {
          const obj = Object.assign(
            {},
            { uuid: item.uuid, "~table~": "mrbase_sys_prompt" }
          )
          getDetele(obj)
            .then((res) => {
              this.isOpen = false
              this.isLoading = false
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
              if (this.desserts.length === 1 && this.params.cpage != 1) {
                this.params.cpage--
                this.params.totalpage--
              }
              this.getData()
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    // 添加参照
    add_prompt() {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$router.push({
        name: "add_edit_advance",
      })
    },
  },
  computed: {
    list() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-data-reference"),
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-data-reference"),
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-data-reference"),
        },
      ]
    },
    headers() {
      const headers = [
        {
          text: this.$t("label_With_reference_to_the_name"),
          align: "start",
          sortable: false,
          value: "prompt_name",
        },
        {
          text: this.$t("label_type"),
          align: "start",
          sortable: false,
          value: "prompt_type",
        },
        {
          text: this.$t("label_The_source_table_name"),
          align: "start",
          sortable: false,
          value: "source_table",
        },
        {
          text: this.$t("label_Take_the_column_value"),
          align: "start",
          sortable: false,
          value: "value_field",
        },
        {
          text: this.$t("label_Show_columns"),
          align: "start",
          sortable: false,
          value: "view_fields",
        },
        {
          text: "",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]
      return headers
    },
  },
  watch: {
    $route(val) {
      if (val.name === "referToList") {
        this.showSkeleton = true
        this.getData()
      }
    },
  },
  beforeDestroy() {},
}
</script>

<style scoped>
.btnGroup {
  position: relative;
}
.addBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 10px;
  transform: rotateZ(45deg);
}
</style>
